module.exports = "\r\n<!-- ko if: loading() -->\r\n<!-- ko if: loginTemplate() === \"default\" -->\r\n<default-login></default-login>\r\n<!-- /ko -->\r\n\r\n<!-- ko if: loginTemplate() === \"concise\" -->\r\n<concise-login></concise-login>\r\n<!-- /ko -->\r\n\r\n<!-- ko if: loginTemplate() === \"smallConcise\" -->\r\n<small-concise-login></small-concise-login>\r\n<!-- /ko -->\r\n<!-- /ko -->";


//////////////////
// WEBPACK FOOTER
// ./src/component/login/tabLogin/TabLogin.html
// module id = 112
// module chunks = 0